export default {
  methods: {
    showErrorMessage(e) {
      if (e.response.data.error) {
        this.notifyError(e.response.data.error.message);
      }
    },

    showValidationError(e) {
      const errorBag = e.response.data.error;
      // This means we have thrown an exception that we want to display an error to the user
      if (errorBag) {
      // If we have specific errors, show these instead
        let errorMessage = errorBag.message;

        if (errorBag.errors) {
          errorMessage = Object.values(errorBag.errors).flat(2).join('<br />');
        }

        this.notifyError(errorMessage);
      }
    },

    notifyError(message, title = 'An error has occurred') {
      this.$notify({
        duration: 7000,
        title,
        text: message,
        type: 'error',
      });
    },
  },
};
